/** Mutable SSE connection state — reset on session switch / run_start. */
export const sseState = {
  toolCallMap: new Map<string, string>(),
  activeThinkingId: null as string | null,
  finalized: false,
  saveResultSeen: false,
  stuckTimer: null as ReturnType<typeof setTimeout> | null,
  openedFiles: new Set<string>(),
  lastEventAt: Date.now(),
  eventsReceived: 0,
  lastEventId: 0,
  gapsDetected: 0,
  sessionStart: Date.now(),
  heldPartialTag: "" as string,
  /** (message_uuid, tool_calls) stashed from the `message_persisted` event
   *  and applied when `run_end` finalizes streaming — message_persisted
   *  fires BEFORE run_end, so the feed item doesn't exist yet at patch time. */
  pendingPersisted: null as { messageUuid: string; toolCalls: unknown[] } | null,
  /** org_id + user_id from run_start — validate SSE events belong to this run */
  runOrgId: "" as string,
  runUserId: "" as string,
};
